import { useEffect } from "react";
import { useProfilerStore } from "../stores/useProfilerStore";
import { Profiler } from "../types/Question";

export const useProfiler = (creationProfiler: Profiler) => {
  const {
    profiler,
    answers,
    isReady,
    currentQuestionId,
    totalQuestions,
    beautyProfilerResults,
    fragranceProfilerResults,
    initialize,
    submitAnswer,
    goBack,
    reset,
    isComplete,
    getCurrentQuestion,
    getProgress,
    computeBeautyProfilerResults,
    computeFragranceProfilerResults,
    gift,
  } = useProfilerStore();

  useEffect(() => {
    if (profiler !== creationProfiler) {
      initialize(creationProfiler);
    }
  }, [creationProfiler, profiler, initialize]);

  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  return {
    answers,
    currentQuestionId,
    totalQuestions,
    isReady,
    isComplete: isComplete(),
    progress: getProgress(),
    submitAnswer,
    getCurrentQuestion,
    goBack,
    reset,
    computeBeautyProfilerResults,
    computeFragranceProfilerResults,
    getBeautyProfilerResults: () => beautyProfilerResults,
    getFragranceProfilerResults: () => fragranceProfilerResults,
    gift,
  };
};
